<int-integrators-details
                         [integrationName]="integrationName"
                         [integrationType]="integrationType"
                         [creating]="creating"
                         [user]="user"
                         [invites]="invites"></int-integrators-details>
<div mat-dialog-content>

  <div *ngIf="creating" class="int-text-container">
    {{description}}
  </div>
  <!-- prettier-ignore -->
  <form [fxShow]="creating" #gaForm="ngForm" (ngSubmit)="save()" fxLayout="row wrap">
      <mat-form-field fxFlex="100%">
        <input matInput #name="ngModel" placeholder="Tracking ID (UA-xxxxxxxx-1)" [(ngModel)]="trackingId"
            autocomplete="name" name="name" pattern="UA-\d+-\d+" required/>
        <mat-error *ngIf="name.invalid && (name.dirty || name.touched)">
          <div *ngIf="name.errors.required">Tracking ID is required</div>
          <div *ngIf="name.errors.pattern">Enter a valid Google Analytics Tracking ID</div>
        </mat-error>
      </mat-form-field>
    </form>

  <div *ngIf="isAdmin && invites.length > 0">
    <button mat-stroked-button color="primary" (click)="onViewInvitesClick()">VIEW ALL INVITES</button>
  </div>

  <div *ngIf="!creating" fxLayout="row" fxLayoutAlign="start center" class="int-add-container">
    <button mat-stroked-button color="primary" (click)="addAnother($event)">
      <mat-icon>add</mat-icon>
      <span class="center-text">ADD ANOTHER ACCOUNT</span>
    </button>
  </div>

  <div *ngIf="!noAccounts && !creating">
    <button mat-stroked-button class="toggle-btn" (click)="toggleShowAccounts()" *ngIf="!showAccounts">
      <mat-icon>expand_more</mat-icon>
      <span>SHOW CONNECTED ACCOUNTS</span>
    </button>
    <button mat-stroked-button class="toggle-btn" (click)="toggleShowAccounts()" *ngIf="showAccounts">
      <mat-icon>expand_less</mat-icon>
      <span>HIDE CONNECTED ACCOUNTS</span>
    </button>
  </div>

  <div *ngIf="!creating" [hidden]="!showAccounts">
    <h4 *ngIf="existingIntegrations.length > 0" class="mr-4">Connected Accounts</h4>
    <div *ngFor="let int of existingIntegrations">Tracking ID: {{ int.friendlyName }}</div>
  </div>
</div>
<div>
  <div fxLayout="row" fxLayoutAlign="end end">
    <button mat-button mat-dialog-close>CANCEL</button>
    <button
      *ngIf="creating"
      mat-raised-button
      color="primary"
      (click)="save($event)"
      [disabled]="!gaForm || !gaForm.form.valid"
    >
      SAVE
    </button>
  </div>
</div>
